import React from 'react';
import { Box } from '@mui/material';
import { TYPE } from '../chrome';
import { COPY } from '../presentationCopy';

const FOLLOW_GREEN = '#1B7A4A';

interface LibraryFollowCornerProps {
  title?: string;
}

const LibraryFollowCorner: React.FC<LibraryFollowCornerProps> = ({
  title = COPY.pageKindLibraryHint,
}) => (
  <Box
    aria-label={title}
    title={title}
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: 88,
      height: 88,
      overflow: 'hidden',
      pointerEvents: 'none',
      zIndex: 2,
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        left: -28,
        width: 120,
        transform: 'rotate(-45deg)',
        bgcolor: FOLLOW_GREEN,
        color: '#ffffff',
        textAlign: 'center',
        fontFamily: TYPE.ui,
        fontSize: 8,
        fontWeight: 800,
        letterSpacing: '0.03em',
        lineHeight: 1.35,
        py: '3px',
        boxShadow: '0 1px 3px rgba(20,22,28,0.28)',
      }}
    >
      {COPY.libraryFollowBadge}
    </Box>
  </Box>
);

export default LibraryFollowCorner;
